import React, { useEffect } from 'react'

declare global {
  interface Window {
    dataLayer: any[]
    $Lightning: any
    webVitals: any
    gtag: (...args: any[]) => void
  }
}

const GTM_ID = 'GTM-K9WW6JBT'

const Gtm: React.FC = () => {
  useEffect(() => {
    if (window.gtag) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    document.head.appendChild(script)
  }, [])

  return (
    <>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}

export default Gtm
